module.exports = __webpack_public_path__ + "static/media/lease2_img8.a125c5da.jpg";